var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4031 11.0276L13.3115 12.7835L10.5386 10.0182L13.3336 7.23068L16.4031 8.97396C16.5843 9.07677 16.735 9.226 16.8399 9.4064C16.9447 9.58681 17 9.79192 17 10.0008C17 10.2096 16.9447 10.4147 16.8399 10.5951C16.735 10.7755 16.5843 10.9248 16.4031 11.0276ZM0.0883543 1.23133C0.0300853 1.37405 7.50333e-05 1.52678 0 1.68101V18.3197C0 18.4915 0.0354995 18.6515 0.0978209 18.7948L8.89776 10.0174L0.0883543 1.23133ZM9.71819 9.19959L12.2884 6.63613L1.75525 0.6542C1.5294 0.524232 1.26653 0.474317 1.00898 0.51249L9.71819 9.19959ZM9.71819 10.836L1.04053 19.4914C1.27562 19.5199 1.52332 19.4788 1.75525 19.3466L12.2663 13.3773L9.71819 10.836Z",
    fill: "#1D7E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.042071ed92ce27da2971727fb6566f40.svg";
export { ForwardRef as ReactComponent };